import { useState } from "react";
import { Alert, Button, ButtonGroup, Card, Col, FloatingLabel, Form, Modal, Row, Spinner, Table } from "react-bootstrap"
import { format } from 'date-fns'
import { useAddScheduleMutation, useDeleteSessionShowMutation, useGetScheduleShowQuery, useSetNewStatusMutation } from "../../../features/CallApi";
import { LoadScreenMin } from "../../UI/LoadScreenMin";
import { Trash } from "react-bootstrap-icons";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useAddSessionsTPMutation, useGetEventTPMutation, useGetSessionsTPMutation } from "../../../features/CallApiV2";
import { ISession } from "../../../interface/ISessionsTP";
import { IEventTP } from "../../../interface/IEventTP";
import { ISchedule } from "../../../interface/ISchedule";

const SessionItem = (props: any) => {
    const [setNewStatus, { isLoading: loadingNewStatus }] = useSetNewStatusMutation()
    const [deleteSessionShow, { isLoading: deletingSession }] = useDeleteSessionShowMutation()
    const deleteSession = (id: string) => {
        if (window.confirm("Удалить сеанс из списка?")) {
            deleteSessionShow(id).unwrap().finally(() => { props.refetch() })
        }
    }
    useEffect(() => {
        console.log(props.session)
    }, [props])
    return (
        <>
            <div className="pb-3 pt-3">
                <Row>
                    <Col>
                        <Row className="border-top">
                            <Col xs={`auto`}>
                                <div className="fw-bold">
                                    Дата: {format(new Date(props.session.startOfEvent), "dd.MM.yy HH:mm")}
                                </div>
                            </Col>
                            <Col xs>
                                {!loadingNewStatus ?
                                    <Form.Check // prettier-ignore
                                        type="switch" id={`IsShow-${props.session.id}`} label={props.session.isShow ? "активен" : "не активен"} onChange={e => {
                                            setNewStatus({
                                                id: props.session.id,
                                                newStatus: e.target.checked
                                            }).unwrap().then(() => {
                                                props.refetch();
                                            });
                                        }}
                                        // defaultChecked={props.session.isShow}
                                        checked={props.session.isShow} /> :
                                    <Spinner />
                                }

                            </Col>
                        </Row>

                    </Col>
                    <Col xs={'auto'} style={{ alignContent: "center" }}>
                        <ButtonGroup>
                            <Button style={{
                                lineHeight: '16px'
                            }} size="sm" className="p-1" onClick={() => {
                                deleteSession(props.session.id);
                            }} variant="danger">
                                <Trash />
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </div>
        </>
    );
}

const AddManualSchedule = ({ showId, refetch }: { showId: string, refetch: () => void }) => {
    const { register, handleSubmit, reset, formState: { errors }, setValue } = useForm();
    const [showForm, setShowForm] = useState(false)
    const [startOfEvent, setStartOfEvent] = useState<any>()
    const [duration, setDuration] = useState<any>()
    useEffect(() => { setValue("showId", showId) }, [showForm])
    const [addSchedule, { isLoading }] = useAddScheduleMutation()

    const addManualSchedule = (data: any) => {
        // public int SessionId { get; set; }
        // public string? NameInPremiera { get; set; }
        // public DateTime StartOfEvent { get; set; }
        // public int? Duration { get; set; }
        // public DateTime EndOfEvent { get; set; }
        // public int? PremieraShowId {  get; set; }
        console.log(data)
        addSchedule(data).unwrap().then(
            (r) => {
                console.log(r)
                if (r.status === "success") {
                    window.alert("Успешно добавлено")
                    refetch()
                }
                if (r.status === "already") {
                    window.alert("Уже есть в расписание")
                    refetch()
                }
            }
        )
    }

    useEffect(() => {
        if (startOfEvent !== null && duration > 0) {
            const sDate = new Date(startOfEvent)
            const cDuration = duration * 60 * 1000
            const cDate = new Date(sDate.getTime() + cDuration)
            const formatDate = format(cDate, "yyyy-MM-dd") + "T" + format(cDate, "HH:mm")
            setValue("endOfEvent", formatDate)
        }
    }, [duration, startOfEvent])

    return (
        <>
            <div className="mb-1 border-bottom">
                <Button onClick={() => { setShowForm(!showForm) }} size="sm" className="mb-1">
                    Добавить вручну
                </Button>
                {showForm &&
                    <Form onSubmit={handleSubmit(addManualSchedule)}>
                        <FloatingLabel className="mb-1" controlId="floatingSelect" label="Id шоу (Число)">
                            <Form.Control type="number" autoComplete="off" defaultValue={""} placeholder="Id шоу Премьере (Число)" {...register("premieraShowId", { required: { value: true, message: "" } })} />
                        </FloatingLabel>
                        <FloatingLabel className="mb-1" controlId="floatingSelect" label="Id сессии (Число)">
                            <Form.Control type="number" autoComplete="off" defaultValue={""} placeholder="Id сессии Премьере (Число)" {...register("sessionId", { required: { value: true, message: "" } })} />
                        </FloatingLabel>
                        <FloatingLabel className="mb-1" controlId="floatingSelect" label="Название Шоу в Премьере">
                            <Form.Control type="text" autoComplete="off" defaultValue={""} placeholder="nameInPremiera" {...register("nameInPremiera", { required: { value: true, message: "" } })} />
                        </FloatingLabel>
                        <FloatingLabel className="mb-1" controlId="floatingSelect" label="Дата и время начала">
                            <Form.Control type="datetime-local" autoComplete="off" defaultValue={""} placeholder="Дата и время начала" {...register("startOfEvent", { onChange: (e) => { setStartOfEvent(e.target.value) } })} />
                        </FloatingLabel>
                        <FloatingLabel className="mb-1" controlId="floatingSelect" label="Продолжительность">
                            <Form.Control type="number" autoComplete="off" defaultValue={""} placeholder="Продолжительность" {...register("duration", { onChange: (e) => { setDuration(e.target.value) } })} />
                        </FloatingLabel>
                        <FloatingLabel className="mb-1" controlId="floatingSelect" label="Дата и время завершения">
                            <Form.Control type="datetime-local" disabled autoComplete="off" defaultValue={""} placeholder="Дата и время завершения" {...register("endOfEvent")} />
                        </FloatingLabel>
                        <Button type="submit" variant="success" size="sm">Добавить</Button>
                    </Form>
                }
            </div>
        </>
    )
}

const SessionsTP = ({ id, showId }: { id: string, showId: number }) => {
    const { refetch } = useGetScheduleShowQuery(showId)
    const [getSessionsTP, { isLoading }] = useGetSessionsTPMutation()
    const [AddSessionsTP, { isLoading: isLoadingAdd }] = useAddSessionsTPMutation();
    const [sessions, setSessions] = useState<any>([])
    const getSessions = () => {
        getSessionsTP(id).unwrap().then((r) => {
            console.log(r)
            setSessions(r.entities || [])
        })
    }

    const formatDateTime = (dateString: string) => {
        const date = new Date(dateString)
        // Добавляем 3 часа (3 * 60 * 60 * 1000 миллисекунд)
        const dateWithOffset = new Date(date.getTime() + (3 * 60 * 60 * 1000))
        return dateWithOffset.toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        })
    }

    const formatDuration = (minutes: number) => {
        const hours = Math.floor(minutes / 60)
        const mins = minutes % 60
        return hours > 0 ? `${hours} ч ${mins} мин` : `${mins} мин`
    }

    const addSession = (session: ISession) => {
        const date = new Date(session.startTime);
        // Добавляем 3 часа (3 * 60 * 60 * 1000 миллисекунд)
        const dateWithOffset = new Date(date.getTime() + (3 * 60 * 60 * 1000));

        const body: ISchedule = {
            showId: showId,
            sessionTPId: session.id,
            startOfEvent: dateWithOffset.toISOString(), // Преобразуем Date в строку
            endOfEvent: new Date(dateWithOffset.getTime() + (session.duration * 60000)).toISOString(), // Вычисляем endOfEvent на основе duration
            sessionId: 1, // или соответствующее значение,
            isShow: false, // или соответствующее значение
            duration: session.duration, // добавьте, если требуется
            premieraShowId: 0, // добавьте, если требуется
            eventId: session.eventId, // добавьте, если требуется (строка, как мы выяснили ранее)
            schemeHallId: 0 // добавьте, если требуется
        };
        console.log(body)
        AddSessionsTP(body).unwrap().then((r: any) => {
            refetch()
        })
    }

    return (
        <>
            <div className="d-grid gap-2">
                {isLoading && <LoadScreenMin height={10} />}
                <Button onClick={getSessions}
                    size="sm"
                >
                    Получить сеансы
                </Button>

                {sessions.length > 0 && (
                    <div className="mt-3">
                        <div className="mb-2">
                            <strong>Найдено сеансов: {sessions.length}</strong>
                        </div>
                        <div className="d-flex flex-column gap-2">
                            {sessions.map((session: ISession) => (
                                <Card key={session.id}>
                                    <Card.Body>
                                        <div className="d-flex">
                                            <div className="flex-fill">
                                                <div className="fw-bold">
                                                    {formatDateTime(session.startTime)}
                                                </div>
                                                <div className="text-muted small">
                                                    Длительность: {formatDuration(session.duration)}
                                                </div>
                                            </div>
                                            <div className="d-grid justify-content-center align-items-center">
                                                <Button size="sm" variant="success" onClick={
                                                    () => { addSession(session) }}
                                                >Добавить</Button>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    </div>
                )}

                {sessions.length === 0 && !isLoading && (
                    <Alert variant="info" className="mt-3">
                        Нет доступных сеансов
                    </Alert>
                )}
            </div>
        </>
    )
}

const GetEventData = ({ showId }: { showId: number }) => {

    const [getEventTP, { isLoading }] = useGetEventTPMutation()
    const { register, handleSubmit, reset, formState: { errors } } = useForm<any>()
    const [result, setResult] = useState<IEventTP | null>(null)
    const submit = (data: any) => {
        getEventTP(data.id).unwrap().then((r) => {
            console.log(r)
            setResult(r)
        })
    }

    return (
        <div>
            <Form onSubmit={handleSubmit(submit)} className="d-grid gap-1">
                <FloatingLabel label="Id мероприятия">
                    <Form.Control placeholder="Id мероприятия"
                        {...register("id", { required: { value: true, message: "ID обязателен" } })} />
                </FloatingLabel>
                <Button size="sm" type="submit">Получить данные</Button>
            </Form>
            {isLoading && <LoadScreenMin height={10} />}
            {result && (
                <>
                    <div className="d-grid gap-3">
                        <Table striped bordered hover className="mt-3" size="sm">
                            <tbody>
                                <tr>
                                    <th>Название</th>
                                    <td>{result.name}</td>
                                </tr>
                                <tr>
                                    <th>Описание</th>
                                    <td>{result.description}</td>
                                </tr>
                                <tr>
                                    <th>Возрастной рейтинг</th>
                                    <td>{result.ageRating}+</td>
                                </tr>
                                <tr>
                                    <th>Режиссер</th>
                                    <td>{result.director}</td>
                                </tr>
                            </tbody>
                        </Table>
                        <SessionsTP showId={showId} id={result.id} />
                    </div>
                </>
            )}
        </div>
    )
}


export const ShowSchedule = ({ showSchedule, setShowSchedule, showId, setShowId, showTitle, setShowTitle }: any) => {
    const { data: scheduleShow, isLoading: isLoadingSchedule, refetch } = useGetScheduleShowQuery(showId)
    const [loadingScreen, setLoadingScreen] = useState<boolean>(false);


    return (<>
        <Modal
            show={showSchedule}
            size={"xl"}
            onHide={() => {
                setShowId(null)
                //  reset()
                setShowSchedule(false)
                setShowTitle()
            }}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <h3>{showTitle}</h3>
            </Modal.Header>
            <Modal.Body>
                <Row>

                    <Col lg={6}>
                        <div className="d-grid gap-2">
                            <AddManualSchedule showId={showId} refetch={refetch} />
                            <GetEventData showId={showId} />
                        </div>
                    </Col>
                    {!loadingScreen ?

                        <Col lg={6} className="">
                            {!isLoadingSchedule ? <>{scheduleShow && scheduleShow?.length > 0 ? <>
                                <div className="g-2">

                                    {scheduleShow.map((session: any) =>
                                        <SessionItem key={session.id} refetch={refetch} session={session} />
                                    )}
                                </div>
                            </> :
                                <div className="text-center fw-bold">Список расписания пуст</div>}</> : <></>}
                        </Col>
                        :
                        <Col>
                            <LoadScreenMin height={30} />
                        </Col>
                    }
                </Row>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    </>)
}